<div class="tab-pane fade show active" id="overview">
    <div class="d-flex justify-content-end mb-2">
        <a class="text-decoration-none">
            <button class="btn back-btn" (click)="OpenSmartVaultModal()">
                Smart Vault
            </button>
        </a>
    </div>

    <div class="container-fluid my-4">
        <div class="roundup-content bg-white shadow p-3 rounded">
            <h3 class="unique-main-title fw-bold mb-3">Smart Vault Savings</h3>

            <!-- User Info -->
            <div class="d-flex align-items-center mb-4">
                <img src="assets\images\profileImg.jpg" alt="User" class="profile-img rounded-circle me-3" width="55"
                    height="55">

                <div>
                    <div class=" ro-title"> Hi, {{User.userName}} </div>
                    <div class="ro-tag"> Welcome to your Smart Vault dashboard!</div>
                </div>
            </div>

            <!-- Stats Section with Rectangle Boxes -->
            <div class="row text-start mb-4 g-3">
                <div class="col-4">
                    <div class="stat-card shadow-sm rounded-3 p-3 d-flex align-items-center justify-content-between">
                        <div>
                            <div class="mb-1 stats-title">Saving Amount</div>
                            <div class="stats-value mb-0">₹ 15,300</div>
                        </div>
                        <img src="http://localhost:4200/assets/icons/Userenddashboard/wallet.png " alt="Saving Icon"
                            class="stats-img">
                    </div>
                </div>

                <div class="col-4">
                    <div class="stat-card shadow-sm rounded-3 p-3 d-flex align-items-center justify-content-between">
                        <div>
                            <div class="mb-1 stats-title">Interest Earned</div>
                            <div class="stats-value mb-0">₹ 1,200</div>
                        </div>
                        <img src="http://localhost:4200/assets/icons/Userenddashboard/roundup.png" alt="Interest Icon"
                            class="stats-img">
                    </div>
                </div>

                <div class="col-4">
                    <div class="stat-card shadow-sm rounded-3 p-3 d-flex align-items-center justify-content-between"
                        style="background-color: #DCFEF6;">
                        <div>
                            <div class="mb-1 stats-title">Total Saving</div>
                            <div class="stats-value mb-0">₹ 16,500</div>
                        </div>
                        <img src=" http://localhost:4200/assets/icons/Userenddashboard/totalbal.png"
                            alt="Total Saving Icon" class="stats-img">
                    </div>
                </div>
            </div>

            <div *ngIf="!isloading">
                <div class="rounded-3 py-2 px-3 mb-4" style="background-color: #EEF9FE;" *ngIf="!userRoundOffDetails || userRoundOffDetails?.isActive">
                    <i class="bi bi-info-circle-fill text-info me-1"></i>
                    <span class="fw-semibold small" >
                        You are currently enrolled in the ₹<strong>{{userRoundOffDetails?.roundOffAmount}}</strong> Round-Up Saving plan.
                    </span>
                </div>
            </div>

            <!-- Transactions Table -->
            <h6 class="fw-bold mb-3">Transactions</h6>
            <div class="roundup-transaction-box">
                <table class="roundup-table w-100 mb-0">
                    <thead>
                        <tr>
                            <th>Date</th> 
                            <th>To</th>
                            <th>Payment Method</th>
                            <th>Total Amount</th>
                            <th>Amount</th>
                            <th>Round-up Amount</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr>
                            <td>12/07/2025</td>
                            <td>Burger King</td>
                            <td>Mobile Wallets</td>
                            <td>₹ 1,200</td>
                            <td>₹ 1120</td>
                            <td>₹ 100</td>
                        </tr>
                        <tr>
                            <td>12/07/2025</td>
                            <td>Amazon</td>
                            <td>Credit Card</td>
                            <td>₹ 850</td>
                            <td>₹ 820</td>
                            <td>₹ 50</td>
                        </tr>
                        <tr>
                            <td>12/07/2025</td>
                            <td>Zomato</td>
                            <td>UPI</td>
                            <td>₹ 420</td>
                            <td>₹ 410</td>
                            <td>₹ 70</td>
                        </tr>
                        <tr>
                            <td>12/07/2025</td>
                            <td>Flipkart</td>
                            <td>Debit Card</td>
                            <td>₹ 2,100</td>
                            <td>₹ 2,010</td>
                            <td>₹ 100</td>
                        </tr>
                        <tr>
                            <td>12/07/2025</td>
                            <td>Swiggy</td>
                            <td>Mobile Wallets</td>
                            <td>₹ 560</td>
                            <td>₹ 530</td>
                            <td>₹ 40</td>
                        </tr>
                    </tbody>
                </table>
                <div class="text-end mt-2 px-3 pb-2">
                    <a href="#" class="small fw-semibold text-primary">View All</a>
                </div>
            </div>

            <!-- IMAGE -->
            <div class="container-fluid my-5">
                <!-- Heading -->
                <div class="fs-2 text-center  mb-4 fw-bold">How It Works</div>

                <!-- Desktop Image (Visible on md and above) -->
                <div class="text-center d-none d-md-block">
                    <img src="assets\images\LoanImages\roundup-horizontal.png" alt="How It Works - Desktop"
                        class="img-fluid" style="max-width: 100%;">
                </div>

                <!-- Mobile Image (Visible on sm and below) -->
                <div class="text-center d-md-none">
                    <img src="assets\images\LoanImages\roundup-vertical.png" alt="How It Works - Mobile"
                        class="img-fluid" style="max-width: 100%;">
                </div>
            </div>
        </div>
    </div>
</div>
<ng-template #roundOffModal>
    <div class="modal-header">
        <button type="button" class="btn-close" aria-label="Close" (click)="modalService.dismissAll()"></button>
    </div>

    <div class="modal-body">
        <app-roundup-savings-enroll (roundOffAmountFetch)="HandleRoundOffEventEmit()"></app-roundup-savings-enroll>
    </div>
</ng-template>